import { createFileRoute } from "@tanstack/react-router";
import { CultivationContainer } from "../../app/views/cultivation/cultivationContainer";

export const Route = createFileRoute("/lungmask")({
  component: CultivationContainer,
});
